import React from 'react';
import { LoginModalProps } from './types';
import { useTranslation } from 'react-i18next';
import Button from "@sharedComponents/Button";
import {ButtonType} from '@sharedComponents/Button/types';
import './Scss/login-modal-content.scss';

const LoginModalContent = (props: LoginModalProps) => {
    const { t } = useTranslation();

    return (
        <div className='login-modal-content'>
            <h3>{t('companyRegistration.promptLoginHeader')}</h3>
            <p>{t('companyRegistration.promptLoginInfo')}</p>
            <Button
                type={ButtonType.PRIMARY}
                className="login-modal-createaccount-button"
                text={t('button.createAccount')}
                onClick={props.handleLogin}
            />
            <h4>{t('companyRegistration.promptLoginHeader2')}</h4>
            <p>{t('companyRegistration.promptLoginInfo2')}</p>
            <Button
                type={ButtonType.SECONDARY}
                className="login-modal-login-button"
                text={t('button.login')}
                onClick={props.handleLogin}
            />
        </div>
    );
};

export default LoginModalContent;
